import { render } from "./MetadataInfo.vue?vue&type=template&id=90982626&scoped=true&ts=true"
import script from "./MetadataInfo.vue?vue&type=script&lang=ts"
export * from "./MetadataInfo.vue?vue&type=script&lang=ts"

import "./MetadataInfo.vue?vue&type=style&index=0&id=90982626&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90982626"]])

export default __exports__